import React from 'react';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MaskedTextField from 'common/components/MaskedTextField';

const datePipe = createAutoCorrectedDatePipe('mm-dd-yyyy');
const MASK = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const DateField = props => (
  <MaskedTextField mask={MASK} pipe={datePipe} {...props} />
);

export default DateField;
